import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MemberInfo, Member, Pet, CheckBoxItem, PetMedicalHistory, CatLitter, Vaccine } from 'src/app/model/member.model';
import { MemberService } from './member.service';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { SelectItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { SelectedItemService } from 'src/app/core/service/selected-item.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { Message } from 'primeng/api';
import { forEach } from 'lodash';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css'],
})
export class MemberComponent implements OnInit {
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  LoginUser: Member;
  editModel: MemberInfo; //預覽表單
  origEditModel: MemberInfo; //編輯前表單
  newEditModel: Pet; //新增寵物表單
  Step: number = 0;
  isOptionLoading: boolean = false;
  isLoading: boolean = false;
  subscribes: Subscription = new Subscription();
  GenderList: SelectItem[];
  LevelList: SelectItem[] | null = null;
  CityList: SelectItem[] | null = null;
  ZipList: SelectItem[] | null = null;
  Address: string = '';
  VarietyList: SelectItem[] | null = null;
  origVarietyTypeList: any[];
  VarietyTypeList: SelectItem[] | null = null;
  SizesList: SelectItem[] | null = null;
  showDs = false;
  uploadmsgs: Message[] = [];
  origCityList: any[];
  origZipList: any[];
  origVarietyList: any[];
  picSize: number;
  activeIndex: number = 0;
  baseUrl = environment.baseUrl;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  MedicalHistoryOption: CheckBoxItem[];
  CatLitterOption: CheckBoxItem[];
  VaccineOption: CheckBoxItem[];
  section = {
    basic: true,
    status: false,
    health: false
  };
  constructor(
    private route: ActivatedRoute,
    private MemberService: MemberService,
    private authenticationService: AuthenticationService,
    private SelectedItemService: SelectedItemService
  ) {}

  ngOnInit(): void {
    var that = this;
    // 取得querystring param
    var query = this.route.queryParams.subscribe((value) => {
      this.CompanyID = value['CompanyID'];
      this.UserID = value['UserID'];
      this.Liff_ID = value['Liff_ID'];
    });

    var currentUser = this.authenticationService.currentMember.subscribe(
      (member) => {
        this.LoginUser = member;
      }
    );
    this.getSelectOptionData();
    this.GetPetMedicalHistoryOptionData();
    this.GetPetCatLitterOptionData();
    this.GetPetVaccineOptionData();
    this.subscribes.add(query);
    this.subscribes.add(currentUser);
  }
  //#region 初始化

  getSelectOptionData() {
    this.isOptionLoading = true;
    const getOption = this.MemberService.GetSelectOptionData(
      this.CompanyID
    ).subscribe((result) => this.GetSelectOptionDataSucceed(result));
    this.subscribes.add(getOption);
  }
  GetPetMedicalHistoryOptionData(){
        const selectOption = this.MemberService.GetPetMedicalHistoryOptionData(this.CompanyID);
        selectOption.toPromise().then((result: any) => {
            this.MedicalHistoryOption = Array.from(result['PetMedicalHistoryOption'] as any[]).map((v) => {
                return {
                    Id: v.ChNo,
                    Name: v.ChName != null ? v.ChName : '',
                    Selected: false,
                    Note: '',
                };
            }); 
        });
  }

  GetPetCatLitterOptionData(){
        const selectOption = this.MemberService.GetPetCatLitterOptionData(this.CompanyID);
        selectOption.toPromise().then((result: any) => {
            this.CatLitterOption = Array.from(result['CatLitterOption'] as any[]).map((v) => {
                return {
                    Id: v.ChNo,
                    Name: v.ChName != null ? v.ChName : '',
                    Selected: false,
                    Note: '',
                };
            }); 
        });
  }

  GetPetVaccineOptionData(){
        const selectOption = this.MemberService.GetPetVaccineOptionData(this.CompanyID);
        selectOption.toPromise().then((result: any) => {
            this.VaccineOption = Array.from(result['VaccineOption'] as any[]).map((v) => {
                return {
                    Id: v.ChNo,
                    Name: v.ChName != null ? v.ChName : '',
                    Selected: false,
                    Date: v.vaccineDate,
                    Note: '',
                };
            }); 
        });
  }
  //#endregion

  //#region 按鈕事件
  NewPet() {
    this.showDs = true;
    this.newEditModel = new Pet();
    this.newEditModel.CompanyID = this.CompanyID;
    this.newEditModel.MemberNo = this.editModel.Member.MemberNo;
    this.newEditModel.SterilizationFlag = "N";
    this.newEditModel.CarryFlag = "N";
    this.newEditModel.hasWafer = "N";
    this.newEditModel.PetMedicalHistory = new PetMedicalHistory();
    this.newEditModel.PetMedicalHistory.MedicalHistoryItems = this.MedicalHistoryOption.map(item => ({
        ...item,
        Selected: false
    }));
    this.newEditModel.CatLitterList = new CatLitter();
    this.newEditModel.CatLitterList.Items = this.CatLitterOption.map(item => ({
        ...item,
        Selected: false
    }));
    this.newEditModel.VaccineList = new Vaccine();
    this.newEditModel.VaccineList.Items = this.VaccineOption.map(item => ({
        ...item,
        Selected: false
    }));
  }
  ChangeView(step: number) {
    switch (step) {
      case 0: //儲存
        this.isOptionLoading = true;
        this.Step = step; 
        this.editModel.Pets.forEach(el=>{
          
          if(!!el.Variety)
            el.Variety = el.Variety.value;
        });
        const saveit = this.MemberService.UpdateMemberInfo(
          this.editModel
        ).subscribe((res) => this.UpdateMemberInfoSucceed(res));
        this.subscribes.add(saveit);
        break;
      case 1: //修改
        this.Step = step;
        break;
      case 2: //放棄修改
        this.Step = 0;
        this.editModel = JSON.parse(JSON.stringify(this.origEditModel));
        break;
      default:
        break;
    }
  }
  SavePet() {
    this.showDs = false;
    if(!!this.newEditModel.Variety)
        this.newEditModel.Variety = this.newEditModel.Variety.value;
    
    const savepet = this.MemberService.CreatePet(
      this.CompanyID,
      this.newEditModel
    ).subscribe((res) => this.CreatePetSucceed(res));
    this.subscribes.add(savepet);
  }
  
  //#endregion

  //#region 資料處理
  ClearInfo() {
    this.editModel = new MemberInfo();
    this.origEditModel = new MemberInfo();
    this.editModel.Member = new Member();
    this.origEditModel.Member = new Member();
    this.newEditModel = new Pet();
  }
  SearchMemberInfo() {
    this.ClearInfo();
    var Members = this.MemberService.GetMemberInfo(
      this.CompanyID,
      this.UserID
    ).subscribe((res) => this.GetMemberSucceed(res));
    this.subscribes.add(Members);
  }
  GetMemberSucceed(res: any): void {
    if (!!res.ErrorFlag == true && res.ErrorFlag == '1') {
      Swal.fire({
        icon: 'error',
        title: res,
      });
      this.isOptionLoading = false;
      return;
    } else {
      this.editModel.Member = res['Member'];
      this.editModel.Member.CompanyID = this.CompanyID;
      this.editModel.Pets = res['Pets']; 
      this.editModel.Pets.forEach((el) => {
        var sizeNm = this.SizesList?.find((s) => s.value == el.Size)?.label;
        if (sizeNm !== undefined) el.SizeName = sizeNm; 
        var vaNm = this.VarietyList?.find((s) => s.value == el.Variety)?.label; 
        if (vaNm !== undefined) el.VarietyName = vaNm;
        var vatNm = this.VarietyTypeList?.find((s)=>s.value == el.VarietyType)?.label; 
        if(vatNm != undefined) el.VarietyTypeName = vatNm;
        var alist = this.origVarietyList?.filter(s=>s.ChValue2 == el.VarietyType);
        el.VarietyList = this.SelectedItemService.convertToSelectItem(
          alist,
          'ChNo',
          'ChName'
        );
        //針對p-dropdown賦值處理
        el.Variety = el.VarietyList?.find(s=>s.value == el.Variety);
        //圖
        if (!!el.OldPhotos && el.OldPhotos.length > 0) {
          el.gallyBox = [];
          el.OldPhotos.forEach((ph) => {
            var path = { source: this.baseUrl + '/' + ph };
            el.gallyBox.push(path);
          });
        }

      });

      var add1 = this.origCityList?.find(
        (s) => s.CityNo == this.editModel.Member.Add1
      )?.CityName;
      
      var add2 = this.origZipList?.find(
        (s) => s.CityNo == this.editModel.Member.Add1 && s.ZipCode == this.editModel.Member.Add2
      )?.Township;
      
      this.Address = add1 + add2;
      this.origEditModel = JSON.parse(JSON.stringify(this.editModel));
      this.isOptionLoading = false;
    }
  }
  UpdateMemberInfoSucceed(res: any) {
    this.isOptionLoading = true;
    this.ClearInfo();
    this.GetMemberSucceed(res);
  }

  CreatePetSucceed(res: any) { 
    if (!!res.ErrorFlag == true && res.ErrorFlag == '1') {
      Swal.fire({
        icon: 'error',
        title: res,
      });
      return;
    } else {
      //處理新加入寵物資料
      // var sizeNm = this.SizesList?.find((s) => s.value == res.Size)?.label;
      // if (sizeNm !== undefined) res.SizeName = sizeNm; 
      // var vaNm = this.VarietyList?.find((s) => s.value == res.Variety)?.label; 
      // if (vaNm !== undefined) res.VarietyName = vaNm;
      // var vatNm = this.VarietyTypeList?.find((s)=>s.value == res.VarietyType)?.label; 
      // if(vatNm != undefined) res.VarietyTypeName = vatNm;
      // var alist = this.origVarietyList?.filter(s=>s.ChValue2 == res.VarietyType);
      // res.VarietyList = this.SelectedItemService.convertToSelectItem(
      //   alist,
      //   'ChNo',
      //   'ChName'
      // );
      // //針對p-dropdown賦值處理
      // res.Variety = res.VarietyList?.find((s: any)=>s.value == res.Variety);
      // this.editModel.Pets.push(res);
      // this.origEditModel.Pets.push(res);
      this.SearchMemberInfo();
    }
  }
  GetSelectOptionDataSucceed(result: any): void {
    
    this.GenderList = [
      { label: '女', value: '0' },
      { label: '男', value: '1' },
    ];
    this.CityList = this.SelectedItemService.convertToSelectItem(
      result['Cities'],
      'CityNo',
      'CityName'
    );
    this.origCityList = result['Cities'];
    this.ZipList = this.SelectedItemService.convertToSelectItem(
      result['ZipCodes'],
      'ZipCode',
      'Township'
    );
    this.origZipList = result['ZipCodes'];
    this.origVarietyList = result['Variety'];
    this.VarietyTypeList = this.SelectedItemService.convertToSelectItem(
      result['VarietyType'],
      'ChNo',
      'ChName'
    );
    this.origVarietyTypeList = result["VarietyType"];
    this.VarietyList = this.SelectedItemService.convertToSelectItem(
      result['Variety'],
      'ChNo',
      'ChName'
    );
    this.SizesList = this.SelectedItemService.convertToSelectItem(
      result['Sizes'],
      'ChNo',
      'ChName'
    );
    this.SearchMemberInfo();
  }
  SelectCity() {
    const alst = this.origZipList.filter(
      (s) => s.CityNo == this.editModel.Member.Add1
    );
    this.ZipList = this.SelectedItemService.convertToSelectItem(
      alst,
      'ZipCode',
      'Township'
    );
  }

  SelectVarietyType(pet: Pet){
    if(!!pet.VarietyType)
    {
      var alist = this.origVarietyList.filter(s=>s.ChValue2 == pet.VarietyType);
      pet.VarietyList = this.SelectedItemService.convertToSelectItem(
        alist,
        'ChNo',
        'ChName'
      );
      
    }else{
      pet.VarietyList = this.SelectedItemService.convertToSelectItem(
        this.origVarietyList,
        'ChNo',
        'ChName'
      );
      
    }
  }
  activeIndexChange($event: any){
    //console.log("e",$event);
  }
  /** 顯示當前寵物病史 */
  public ShowPetMedicalHistory(rowData: Pet): string {
      let medical = '';
      const item = rowData.PetMedicalHistory.MedicalHistoryItems;
      for (let i = 0; i < item.length; i++) {
          if (item[i].Selected) medical += (medical.length > 0 ? '、' : '') + item[i].Name;
      }
      if(!!rowData.PetMedicalHistory.MedicalHistoryItemsNote)
      {
        medical += (medical != ''? '、' : '') + rowData.PetMedicalHistory.MedicalHistoryItemsNote;
      }
      return medical;
  }
  public ShowPetCatLitter(rowData: Pet): string {
      let medical = '';
      const item = rowData.CatLitterList.Items;
      for (let i = 0; i < item.length; i++) {
          if (item[i].Selected) medical += (medical.length > 0 ? '、' : '') + item[i].Name;
      }
      if(!!rowData.CatLitterList.Note)
      {
        medical += (medical != ''? '、' : '') + rowData.CatLitterList.Note;
      }
      return medical;
  }
  public ShowPetVaccine(rowData: Pet): string {
      let medical = '';
      const item = rowData.VaccineList.Items;
      for (let i = 0; i < item.length; i++) {
          if (item[i].Selected) medical += (medical.length > 0 ? '、' : '') + item[i].Name;
      }
      if(!!rowData.VaccineList.Note)
      {
        medical += (medical != ''? '、' : '') + rowData.VaccineList.Note;
      }
      return medical;
  }
  SetPetMedicalHistory(data: any) {
      const setPetMedicalHistory = this.MemberService.SetPetMedicalHistory(data,this.CompanyID).subscribe((_) => {
            // this.messageService.add({ severity: 'success', summary: '更新成功', detail: '結果筆數：1' });
      });
  }
  SetPetCatLitter(data: any) {
      const setPetCatLitter = this.MemberService.SetPetCatLitter(data,this.CompanyID).subscribe((_) => {
            // this.messageService.add({ severity: 'success', summary: '更新成功', detail: '結果筆數：1' });
      });
  }
  SetPetVaccine(data: any) {
      const setPetVaccine = this.MemberService.SetPetVaccine(data,this.CompanyID).subscribe((_) => {
            // this.messageService.add({ severity: 'success', summary: '更新成功', detail: '結果筆數：1' });
      });
  }
  //#endregion

  //#region 圖片上傳處理
  /**選擇圖片 */
  onPhotoUpload(event: any, pet: Pet, PetPhoto: any) {
    if (pet.NewPhotoUrls == undefined || pet.NewPhotoUrls.length == 0) {
      pet.NewPhotos = [];
      pet.NewPhotoUrls = [];
    }
    let totalSize = 0;
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
    for (const file of event.files) {
      if (!allowedTypes.includes(file.type)) {
        Swal.fire({
          icon: 'error',
          title: '上傳失敗',
          text: '請選擇有效的圖片 (JPEG、PNG、GIF...)',
          footer: '',
        });
        continue;
      }
      
      if (file.size > 5000000) {
        Swal.fire({
          icon: 'error',
          title: '上傳失敗',
          text: '檔案大小超過5M',
          footer: '',
        });
        this.picSize = (!!file.size && file.size>0)?file.size/1024:0;
        this.picSize = parseFloat(this.picSize.toFixed(2));
        continue;
      } else {
        totalSize += file.size;
        if (totalSize > 20000000) {
          Swal.fire({
            icon: 'error',
            title: '上傳失敗',
            text: '總檔案大小超過20M',
            footer: '',
          });
          return;
        }
        this.picSize = (!!totalSize && totalSize>0)?totalSize/1024:0;
        this.picSize = parseFloat(this.picSize.toFixed(2));
        pet.NewPhotos.push(file);
        const reader = new FileReader();
        reader.onload = (el: any) => {
          // 在這裡處理讀取完成後的操作，例如將圖片資料存儲到陣列中
          const photoData = el.target.result;

          pet.NewPhotoUrls.push(photoData);
        };
        reader.readAsDataURL(file);
      }
    }
    let count = 0;
    pet.NewPhotos.forEach((el) => {
      count += el.size;
      if (count > 20000000) {
        //this.uploadError = true;
        Swal.fire({
          icon: 'error',
          title: '上傳失敗',
          text: '總檔案大小超過20M',
          footer: '',
        });
        
        //this.maxLimit = true;
      }
    });
    
    PetPhoto.clear();
  }
  /**除舊 */
  DeleteOldPhoto(data: string, pet: Pet) {
    pet.OldPhotos = pet.OldPhotos.filter((s) => s != data);
  }
  /**除新 */
  DeleteNewPhoto(url: any, pet: Pet) {
    pet.NewPhotos = pet.NewPhotos.filter((s) => s != url);
    pet.NewPhotoUrls = pet.NewPhotoUrls.filter((s) => s != url);
  }
  //#endregion

  //驗證
  EditRequired(){
    return !!this.newEditModel.PetName && !!this.newEditModel.Variety && !!this.newEditModel.VarietyType;
  }
  UpdateRequired(){ 
    var res = true;
    this.editModel.Pets.forEach(s=>{
      if(!!s.PetName == false || !!s.Variety == false) res = false;
    });
    return res && !!this.editModel.Member.Name && !!this.editModel.Member.Telephone;
  }

  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
